module.exports = __webpack_public_path__ + "static/kontaktlinsen-ba11c45c4cc325116fe40d1cf9683c96.jpg";